import * as React from 'react'
import {HashRouter, Route, Switch, withRouter} from 'react-router-dom'
import ClientAnalyze from './clientAnalyze'
import ClientManage from './clientManage'
import ClientDetail from './clientManage/clientDetails'
// import NewMechanismFee from './mechanismFee/newMechanismFee'

import Content from '../common/content'



// const mechanismFees = () => (
//   <div style={{height: '100%', display: 'flex', flex: 1}}>
//     <Content>
//       <Switch>
//         <Route exact path='/mechanismFee' component={MechanismFee}/>
//         <Route exact path='/mechanismFee/add/:id?' component={NewMechanismFee}/>
//       </Switch>
//     </Content>
//   </div>
// );

const clientAnalyzes = () => (
  <div style={{height: '100%', display: 'flex', flex: 1}}>
    <Content>
      <Switch>
        <Route exact path='/clientAnalyze' component={ClientAnalyze}/>
      </Switch>
    </Content>
  </div>
);

const clientManages = () => (
  <div style={{height: '100%', display: 'flex', flex: 1}}>
    <Content>
      <Switch>
        <Route exact path='/clientManage' component={ClientManage}/>
        <Route exact path='/clientManage/detail/:customerId?/:empno?/:company?/:groupName?/:agencyName?' component={ClientDetail}/>
      </Switch>
    </Content>
  </div>
);


const ClientSys = () => (
  <div style={{
    position: 'relative',
    height: '100%', display: 'flex', flex: 1
  }}>
    <HashRouter basename='clientSys'>
      <Switch>
        {/*客户分析*/}
        <Route path='/clientAnalyze' component={clientAnalyzes}/>
        {/*客户管理*/}
        <Route path='/clientManage' component={clientManages}/>
      </Switch>
    </HashRouter>
  </div>
);

export default withRouter(ClientSys)